import { useNavigate } from "react-router-dom";

export const ContactBanner = () => {
  const navigate = useNavigate();

  const handleContactClick = () => {
    navigate("/contact-us");
  };

  return (
    <div className="w-full flex justify-center">
      <div className="mx-4 md:mx-8 my-8 max-w-2xl bg-[#454444] rounded-2xl px-8 max-w-98 py-8 flex flex-col sm:flex-row items-center justify-between gap-8">
        <div>
          <h3 className="text-white text-xl font-bold mb-1">
            Still need help?
          </h3>
          <p className="text-gray-400 text-sm max-w-80">
            Our specialized concierge team is available 24/7 to resolve complex
            payout queries.
          </p>
        </div>
        <button
          className="bg-orange-500 hover:bg-orange-600 text-white font-semibold px-6 py-3 rounded-lg whitespace-nowrap transition-colors"
          onClick={handleContactClick}
        >
          Contact Us
        </button>
      </div>
    </div>
  );
};
